let latestWorldxCenterEvidence = null;

export function publishWorldxCenterEvidence(evidence) {
  latestWorldxCenterEvidence = evidence && Number.isInteger(evidence.sectorIndex)
    ? { ...evidence }
    : null;
  return latestWorldxCenterEvidence;
}

export function readWorldxCenterEvidence() {
  return latestWorldxCenterEvidence ? { ...latestWorldxCenterEvidence } : null;
}

export function clearWorldxCenterEvidence() {
  latestWorldxCenterEvidence = null;
}
